import i18n from '@/lang';
/* unplugin-vue-components disabled */
import { Icon as __unplugin_components_0 } from 'vant/es';
import 'vant/es/icon/style/index';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "mine"
  }, [_c('div', {
    staticClass: "headtop"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/MH3.9/EquipmentInstallation.png"),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.user.name))])]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "myOrder"
  }, [_c('h2', [_vm._v(i18n.tc("127"))]), _c('div', {
    staticClass: "orderStatus"
  }, _vm._l(_vm.orderStatus, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "box",
      on: {
        "click": function ($event) {
          return _vm.goMyorder(item);
        }
      }
    }, [_c(__unplugin_components_0, {
      staticClass: "icon",
      attrs: {
        "name": item.img
      }
    }), _c('span', [_vm._v(_vm._s(item.name))])], 1);
  }), 0)])]), _c('Group', [_c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "is-link": "",
      "title": i18n.tc("126")
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.goAdderss.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/map-square-o34_34@3x.png"
    }
  })])]), _c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "is-link": "",
      "title": i18n.tc("254")
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.logout.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/logout.png"
    }
  })])])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };